import { PageContentLayout } from '@/creditflowresearch/ui/common/components/ContentLayouts';
import BondsContainer from '@/creditflowresearch/ui/components/bonds';
import withApplicationPropsV2 from '@/creditflowresearch/application/withApplicationPropsV2';
import BondsContextProvider from '@/creditflowresearch/application/Bonds/BondsContext';
import FiltersContextProvider from '@/creditflowresearch/application/FiltersContext';
import BwicTableContextProvider from '@/creditflowresearch/application/Bonds/BwicTableContext';
import InventoryTableContextProvider from '@/creditflowresearch/application/Bonds/InventoryTableContext';
import { getServerSideAssetClasses } from '@/creditflowresearch/application/Bonds/serverSide/getServerSideAssetClasses';
import { getServerSideFiltersData } from '@/creditflowresearch/application/Bonds/serverSide/getServerSideFiltersData';
import { getServerSideBonds } from '@/creditflowresearch/application/Bonds/serverSide/getServerSideBonds';
import getServerSideBondsBreadcrumbs from '@/creditflowresearch/application/Breadcrumbs/serverSide/getServerSideBondsBreadcrumbs';
import BondsAssetClassesContextProvider from '@/creditflowresearch/application/Bonds/BondsAssetClassesContext';
import PageFiltersContextProvider from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import BondsFiltersContextProvider from '@/creditflowresearch/application/Bonds/BondsFiltersContext/BondsFiltersContext';
import UserPlan from '@creditflowresearch/user-plan/UserPlan';
import { checkAccessByProducts, checkAccessByRegions } from '@/creditflowresearch/application/User/access';

export const getServerSideProps = withApplicationPropsV2(async (context) => {
  const { userPlanState, productsRegions } = context;
  const { products, regions, plan } = userPlanState;
  const { productIds, regionIds } = productsRegions;
  const conditions = [
    UserPlan.isPro(plan),
    checkAccessByProducts(productIds, products),
    checkAccessByRegions(regionIds, regions),
  ];

  const assetClasses = await getServerSideAssetClasses(context);
  const filtersPayload = await getServerSideFiltersData(context, assetClasses, conditions);
  const breadcrumbs = getServerSideBondsBreadcrumbs();

  const { bwicData, inventoriesData } = await getServerSideBonds(context, { payload: filtersPayload }, conditions);

  return ({
    props: {
      assetClasses,
      bwicData,
      inventoriesData,
      filtersPayload,
      breadcrumbs,
    },
  });
}, { needsLegacyDictionaries: false });

const BondsContent = () => (
  <PageContentLayout>
    <BondsContainer />
  </PageContentLayout>
);

export default (props) => {
  const {
    assetClasses,
    filtersPayload,
    bwicData,
    inventoriesData,
  } = props;
  const { filter, ...baseParams } = filtersPayload;
  return (
    <PageFiltersContextProvider>
      <BondsAssetClassesContextProvider initial={ assetClasses }>
        <FiltersContextProvider initial={ { baseParams, updateLocation: true } }>
          <BondsFiltersContextProvider initialFilter={ filter }>
            <InventoryTableContextProvider initial={ inventoriesData }>
              <BwicTableContextProvider initial={ bwicData }>
                <BondsContextProvider>
                  <BondsContent />
                </BondsContextProvider>
              </BwicTableContextProvider>
            </InventoryTableContextProvider>
          </BondsFiltersContextProvider>
        </FiltersContextProvider>
      </BondsAssetClassesContextProvider>
    </PageFiltersContextProvider>
  );
};
